import React from "react";
import WorkItems from "./WorkItems";
import Reveal from "../ui/Reveal";

/** `bento`: mixed-size layout, only used for the unfiltered overview. */
const Works = ({ items, bento, onOpenProject }) => (
  <ul className="work__grid" data-bento={bento || undefined}>
    {items.map((project, i) => (
      <li key={project.slug} className="work__cell">
        <Reveal fill index={i % 3}>
          <WorkItems project={project} fig={i + 1} onOpen={() => onOpenProject(project.slug)} />
        </Reveal>
      </li>
    ))}
  </ul>
);

export default Works;
